import { pubsub } from '@services';
import { notyf } from '@modules';

class QuantityInput extends HTMLElement {
  _input = this.querySelector('input');
  #buttons = this.querySelectorAll('button');

  connectedCallback() {
    this.#buttons.forEach((button) => {
      button.addEventListener('click', (event) => this.#handleStep(event.currentTarget.name));
    });

    this._input.addEventListener('change', () => {
      this.#constrainAndUpdateInput(this._input.value);
      this._publishQuantityChange();
    });
  }

  /**
   * Handle the step up or step down of the quantity
   * @param {string} type - The type of step to be taken
   */
  #handleStep(type) {
    const value = parseInt(this._input.value);
    const step = parseInt(this._input.step) || 1;
    const newValue = type === 'minus' ? Math.max(value - step, 0) : value + step;
    const updatedValue = this.#constrainAndUpdateInput(newValue);

    if (parseInt(updatedValue) !== parseInt(value)) this._publishQuantityChange();
  }

  /**
   * Constrain and update the input.
   * @param {number} newValue - The new value.
   * @returns {number} The constrained value.
   */
  #constrainAndUpdateInput(newValue) {
    const { min, max } = this._input;
    this._input.value = newValue;

    if (newValue >= max && max !== '') {
      notyf.error(window.toast_translations.product.quantity_error_max.replace('{{ max }}', max));
      this._input.value = max;
    } else if (newValue <= min) this._input.value = min;

    return this._input.value;
  }

  _publishQuantityChange() {
    pubsub.publish('quantity:change', {
      line: this.dataset?.itemIndex,
      quantity: this._input.value,
    });
  }
}

if (!customElements.get('quantity-input')) {
  customElements.define('quantity-input', QuantityInput);
}

export { QuantityInput };
